<script>
import { mdiSlashForward } from '@mdi/js';
import DaftarTagihan from './DaftarTagihan.vue';
import RiwayatPembayaran from './RiwayatPembayaran.vue';
import axios from 'axios';

export default {
    data() {
        return {
            icons: {
                mdiSlashForward
            },
            breadcrumbs: [
            {
                text: 'Home',
                disabled: false,
                href: '/orangTua/dashboard',
            },
            {
                text: 'Informasi Pembayaran',
                disabled: true,
            },
            ],
            tab: null,
            tabItems: [
            { tab: 'Daftar Tagihan', content: DaftarTagihan },
            { tab: 'Riwayat Pembayaran', content: RiwayatPembayaran }
            ],
            profile: null
        }
    },
    mounted() {
        const profileEndpoint = process.env.VUE_APP_ROOT_API + '/api/ortu/profile';
        axios.get(profileEndpoint)
        .then((response) => {
            this.profile = response.data.data;
        })
        .catch((error) => {
            const profileContainer = document.getElementById('profile-container');
            profileContainer.innerHTML = '<span class="alert alert-danger">Tidak dapat mengambil data profil mahasiswa</span>';
        });
    }
}
</script>

<template>
    <main>
        <v-col cols="12" md="12">
            <v-card class="d-flex justify-end mb-6" flat tile>
                <v-breadcrumbs :items="breadcrumbs" large>
                    <template v-slot:divider>
                        <v-icon>{{ icons.mdiSlashForward }} </v-icon>
                    </template>
                </v-breadcrumbs>
            </v-card>
        </v-col>
        
        <v-col>
            <h2>Informasi<span class="fw-bold"> &nbsp;Tagihan dan Pembayaran</span></h2>
            <v-card>
                <v-card-text id="profile-container">
                    <div v-if="profile != null">
                        <h5 v-text="profile.nama_mahasiswa"></h5>
                        <p>
                            NIM: <span class="fw-bold">{{ profile.nim }}</span> 
                            &mdash; 
                            Prodi <span class="fw-bold">{{ profile.prodi_mahasiswa }}</span>
                            (Fakultas {{ profile.fakultas_mahasiswa }})
                        </p>
                    </div>
                </v-card-text>
                
                <v-tabs v-model="tab">
                    <v-tab v-for="item in tabItems" :key="item.tab">
                        {{ item.tab }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item v-for="item in tabItems" :key="item.tab">
                        <v-card flat>
                            <v-card-text>
                                <component v-bind:is="item.content"></component>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
                
            </v-card>
        </v-col>
    </main>
</template>